export default __webpack_public_path__ + "static/media/hand.70167e6f.png";